const types = [
  'Bracelet',
  'Earring',
  'Necklace',
  'Ring',
  'Anklet',
];

export default types;
